import Briefcase from '../../src/legacy/Briefcase.tsx';
export default Briefcase;
